<template>
  <div>
    <div v-for="option in questionOptions" :key="option.id" class="row">
      <div class="col--12">
        <div v-if="!option.other">
          <div class="row">
            <div class="col">
              <input
                v-enter-to-tab
                type="radio"
                class="m-2 EnterToTab"
                :id="option.id"
                :name="questionId"
                :checked="option.selected"
                :value="option.name"
                :disabled="viewMode"
                @click="answered(option.id)"
              >
              <label :for="option.id" class="d-inline text-break">{{ option.name }}</label><br>
            </div>
          </div>
        </div>
        <div v-else>
          <input
            v-enter-to-tab
            :id="option.id"
            :name="questionId"
            :checked="option.selected"
            :value="option.name"
            :disabled="viewMode"
            type="radio"
            class="m-2 align-middle EnterToTab"
            @click="answered(option.id)"
          >
          <label :for="option.id">{{ option.name }}</label>
          <AppInput type="text" :error-msg="$t('surveyQuestionScreen.openAnswerOption.errorMsgText')"
                    :input-value="otherText" :is-disabled="!option.selected" :is-readonly="viewMode"
                    @blur="answered(option.id)" @change="valueChange" />
          <br>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppInput from "../../AppInput.vue";

export default {
  'name': 'SingleOption',
  components: {AppInput},
  'props': {
    'questionId': 0,
    'answerName': '',
    'questionOptions': Array,
    'viewMode': {
      'type': Boolean,
      'required': false
    }
  },
  'methods': {
    'valueChange': function (e) {
      this.otherText = e.detail.value;
    },
    answered(questionOptionId) {
      if (this.viewMode) {
        return;
      }

      let selectedIndex
      const questionOptions = this.questionOptions.map((option, index) => {
        if (option.id === questionOptionId) {
          selectedIndex = index
          return { ...option, 'selected': true };
        } else {
          return { ...option, 'selected': false };
        }
      })
      this.$emit('onHideConditional', questionOptions)

      let text
      questionOptions.forEach((q) => {
        if (q.selected && q.other) {
          text = this.otherText
        } else {
          text = null
        }
      })
      if (questionOptions[selectedIndex].conditional) {
        this.$emit('onShowConditional', questionOptions[selectedIndex], true)
      }
      this.$emit('onAnswered', questionOptions, text)
    },
    checkConditionals() {
      this.questionOptions.forEach((option) => {
        if (option.conditional) {
          this.$emit('onShowConditional', option, option.selected)
        }
      })
    }
  },
  data() {
    return {
      'otherText': ''
    }
  },
  created() {
    this.otherText = this.answerName === null ? '' : this.answerName
  },
  mounted() {
    this.checkConditionals()
  }
}
</script>
